export default "__VITE_ASSET__CxkbRgoG__"